import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=4dcb6898&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb6898",
  null
  
)

component.options.__file = "Notice.vue"
export default component.exports